import React, { Fragment, PureComponent } from 'react';
import Messages from '../../../chat/components/Messages';
import NewMessage from '../../../common/components/NewMessage';
import Lightbox from '../../../chat/components/Lightbox';
import Badge from '../Badge';
import cn from 'classnames';
import SvgIcon from '../../../common/SvgIcon';
import Button from '../../../common/components/Button';
import RoomsList from './shared/components/RoomsList';
import { allowedToChatType, getChatName } from './shared/contstants/constants';
import ChatTitle from './shared/components/ChatTitle';
import MediFilesBlock from './shared/components/MediFilesBlock';

// const roomTypes = [
//   'reception',
//   'triple_function_room',
//   'living_room',
//   'master_bedroom',
//   'children_bedroom',
//   'nursery',
//   'dining_room',
//   'home_office',
//   'bathroom',
//   'playroom',
//   'hallway',
//   'terrace_or_patio',
//   'kitchen',
//   'other',
// ];

export default class Chat extends PureComponent {
  onNewData(data) {
    const { setUnreadCount, updateChatInfo } = this.props;
    updateChatInfo(data);
  }

  subscribeToChatChannel() {
    const { customerId } = this.props;
    const room = customerId ? `user:${customerId}` : 'user';
    this.chatChannel = App.cable.subscriptions.create(
      {
        channel: 'ChatChannel',
        room,
      },
      {
        connected: function() {},
        disconnected: function() {},
        received: data => this.onNewData(data),
      },
    );
  }

  unsubscribeChatChannel() {
    if (this.chatChannel) {
      this.chatChannel.unsubscribe();
    }
  }

  componentDidMount() {
    const { chat, chats, activeChatId, setActiveChat } = this.props;
    if (!(chat && chat.id) && chats.length > 0) {
      // `activeChatId` is the room the `?chat=` link in a notification email
      // named; anything else opens on the first room.
      setActiveChat(chats.find(room => room.id === activeChatId) || chats[0]);
    }
    this.subscribeToChatChannel();
  }

  componentWillUnmount() {
    this.unsubscribeChatChannel();
  }

  nonActiveChatsNewMessages(chats) {
    return chats.some(c => !c.active && c.new_messages_count > 0);
  }

  renderChatInner() {
    const {
      chatFullsize,
      setActiveChat,
      chats,
      toggleChatFullsize,
      toggleChat,
      toggleSelectChatRooms,
      message,
      messages,
      currentUser,
      chat,
      messagesInitialized,
      messagesInitializationError,
      timestamp,
      loadLastMessages,
      readMessages,
      loadMessages,
      toggleScrollToBottomEffect,
      scrollToBottomEffect,
      onNewMessages,
      loadPrevPage,
      openLightbox,
      sendMessage,
      updateMessage,
      addImages,
      removeImage,
      saveDraftMessage,
      lightboxImage,
      closeLightbox,
      labels,
      role,
      chatSelectRoomOpen,
    } = this.props;

    const chatActive = chat && chat.active;

    return (
      <div
        className={cn('chat-popup_window', role, {
          '-fullsize': chatFullsize,
          '-select-chat-room': chatSelectRoomOpen,
        })}
      >
        <div className="chat-popup_rooms-list">
          <RoomsList chatFullsize={chatFullsize} chats={chats} setActiveChat={setActiveChat} />
        </div>
        <div className="chat-popup_room">
          <ChatTitle
            onFullSizeChange={toggleChatFullsize}
            onOpenSideMenu={toggleSelectChatRooms}
            toggleChat={toggleChat}
            chatFullsize={chatFullsize}
            chats={chats}
          />

          {!allowedToChatType.includes(chat.service_type) && <MediFilesBlock />}

          {chatActive &&
            allowedToChatType.includes(chat.service_type) && (
              <Messages
                popup={true}
                messages={messages}
                chat={chat}
                me={currentUser}
                messagesInitialized={messagesInitialized}
                messagesInitializationError={messagesInitializationError}
                timestamp={timestamp}
                loadLastMessages={loadLastMessages}
                readMessages={readMessages}
                load={loadMessages}
                onNewMessages={onNewMessages}
                toggleScrollToBottomEffect={toggleScrollToBottomEffect}
                scrollToBottomEffect={scrollToBottomEffect}
                labels={labels}
                loadPrevPage={loadPrevPage}
                openLightbox={openLightbox}
                role={role}
              />
            )}

          {chatActive &&
            allowedToChatType.includes(chat.service_type) && (
              <div className="chat-popup_footer">
                <NewMessage
                  message={message}
                  update={updateMessage}
                  send={sendMessage}

                  chatId={chat.id}
                  role={role}
                  addImages={addImages}
                  removeImage={removeImage}
                  onBlur={saveDraftMessage}
                />
              </div>
            )}
        </div>

        <Lightbox image={lightboxImage} close={closeLightbox} />
      </div>
    );
  }

  renderButton() {
    const {
      chat,
      unreadCount,
      visible,
      setUnreadCount,
      loadUnreadCount,
      toggleChat,
      customerId,
      updateChatInfo,
    } = this.props;
    return (
      <Button
        className={cn('chat-popup_control', '-mobile-80px-up', {
          '-opener': !visible,
          '-closer': visible,
          '-new-messages': !visible && unreadCount > 0,
        })}
        onClick={() => toggleChat()}
      >
        {!visible && <SvgIcon icon="icon-messages" />}
        <Badge
          chatId={chat.id}
          count={unreadCount}
          load={loadUnreadCount}
          setUnreadCount={setUnreadCount}
          updateChatInfo={updateChatInfo}
          customerId={customerId}
        />
      </Button>
    );
  }

  render() {
    const { chat, chats, currentUser, visible, inlineBadge } = this.props;
    // The popup body reads the active room throughout, and there is none until
    // componentDidMount has picked one. Rendering it a frame early threw out of
    // ChatTitle and took the whole widget - button included - down with it,
    // which is what an email link arriving with `visible` already true hit.
    const roomReady = Boolean(chat && chat.id);
    return currentUser && chats.length > 0 ? (
      <div className={cn('chat-popup', { '-open': visible, '-inline-badge': inlineBadge })}>
        {chat ? this.renderButton() : null}
        {visible && roomReady ? this.renderChatInner() : null}
      </div>
    ) : null;
  }
}



// WEBPACK FOOTER //
// ./app/javascript/customer_chat/components/chat/Chat.js